/* eslint-env browser */
/* eslint-disable complexity */
import { inject, observer } from 'mobx-react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import * as React from 'react';

import { ILocalization, withLocalization } from 'bernie-l10n';

import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';
import { IClickstreamAnalytics } from '@shared-ui/clickstream-analytics-context';
import { SortAndFiltersViewType } from '@shared-ui/search-tools-lodging';

import { SearchResultsStore } from 'stores/search-results-store';
import { ViewTracker } from 'src/common/stores/contexts/viewTracker';

import { SortAndFilterModel } from 'components/common/search-form/fields/filter-types';

import { UitkSpacing } from 'uitk-react-spacing';

import { MapPreview } from 'src/common/components/search/map/map-preview';
import { parse } from 'query-string';
import { SearchForm } from 'components/common/search-form';
import { UniversalSortFilterWrapper } from './sort-filter/universal-sort-filter';

export interface SidebarProps extends RouteComponentProps {
  searchResults?: SearchResultsStore;
  l10n?: ILocalization;
  withFilters?: boolean;
  tracker: IClickstreamAnalytics;
  viewTracker: ViewTracker;
}

@withLocalization
@inject('searchResults')
@observer
class SidebarComponent extends React.Component<SidebarProps> {
  public static defaultProps = {
    isActive: false,
    l10n: null,
    withFilters: true,
  };

  public scrollToTop() {
    window.scrollTo(0, 0);
  }

  // eslint-disable-next-line complexity
  public render() {
    const { searchResults, withFilters, tracker, viewTracker } = this.props;
    const searchCriteria = searchResults && searchResults.searchCriteria;
    const regionId = searchCriteria && searchCriteria.regionId;
    const latLong = searchCriteria && searchCriteria.latLong;
    const group = searchCriteria && searchCriteria.group;
    const { l10n, location } = this.props;
    const { formatText } = l10n;

    const searchResultsCriteria = searchResults && searchResults.searchCriteria;
    const sortAndFilterOptions: SortAndFilterModel = searchResults && searchResults.sortAndFilter && searchResults.sortAndFilter.options;
    const sortAndFilterDefaults: any = searchResults && searchResults.sortAndFilter && searchResults.sortAndFilter.defaults;
    const filters = searchResults && searchResults.searchAndFilterDisplayOptions && searchResults.searchAndFilterDisplayOptions.filters;
    const displayFields = filters && filters.displayFields;
    const ignoreFields = filters && filters.ignoreFields;
    const mapImage = searchResults && searchResults.map && searchResults.map.staticMapSrc;
    const pwaMapOverlay: boolean = Boolean(parse(location.search).pwaOverlay === 'map');
    const shouldShowSidebar = regionId || latLong || group || sortAndFilterOptions;
    const displayFieldsNoSort = displayFields && displayFields.filter(item => item !== 'sort');

    return (
      <>
        {shouldShowSidebar && (
          <section data-stid="desktop-sidebar">
            {searchResults && searchResults.map && (
              <div>
                <MapPreview mapImage={mapImage} viewTracker={viewTracker} tracker={tracker} />
              </div>
            )}
            {withFilters && (
              <>
                <h2 className="is-visually-hidden">{formatText('hotels.searchResults.filtersDialog.title')}</h2>
                {!pwaMapOverlay && (
                  <UitkSpacing padding={{ blockend: 'twelve' }}>
                    <Experiment name="Universal_Sort_and_Filter_Lodging">
                      <ExperimentControl>
                        <SearchForm
                          model={searchResultsCriteria}
                          sortAndFilterOptions={sortAndFilterOptions}
                          sortAndFilterDefaults={sortAndFilterDefaults}
                          provideDefaultSubmitButton={false}
                          displayFields={displayFieldsNoSort}
                          ignoreFields={ignoreFields}
                          autoSubmit={true}
                          searchable={true}
                          afterSubmit={this.scrollToTop}
                          lazyLoadFromIndex={7}
                        />
                      </ExperimentControl>
                      <ExperimentVariant bucket={1}>
                        <UniversalSortFilterWrapper view={SortAndFiltersViewType.FILTERS} />
                      </ExperimentVariant>
                    </Experiment>
                  </UitkSpacing>
                )}
              </>
            )}
          </section>
        )}
      </>
    );
  }
}

export const Sidebar = withRouter(SidebarComponent);
